import React from 'react';
import { AddToCartReferType } from '@/constants/track';

import { getDeliveryDate } from '@/utils/common/porder';
import type { FeatureProductProperties } from './type';
import { BaseProductType } from '@/types/product';
import { CmsSsrComponentProps } from '@/types/cms';
import SkuHorizontalProductCard from '@/components/common/ProductCard/sku-product/horizontal';

interface ProductThreeProps {
  data: Partial<BaseProductType>[];
  properties?: FeatureProductProperties;
  eventKey: string;
  position: number;
  trackingContext?: CmsSsrComponentProps['trackingContext'];
  isPreview?: boolean;
}

const ProductThree: React.FC<ProductThreeProps> = ({
  data,
  properties,
  eventKey,
  position,
  trackingContext,
  isPreview
}) => {
  return (
    <div className="flex flex-col gap-5 px-2 pt-2 pb-10">
      {data.map((item, index) => {
        return (
          <SkuHorizontalProductCard
            key={item.id}
            addCartParams={{
              referType: AddToCartReferType.normal,
              deliveryDate: getDeliveryDate()
            }}
            positionInfoT2={{
              modSecPos: {
                mod_nm: eventKey,
                mod_pos: position
              },
              prodPos: index,
              context: {
                tag_key: item?.entrance_tag?.tag_key,
                tag_name: item?.entrance_tag?.tag_name,
                ...trackingContext
              }
            }}
            data={item}
            showAddBtn={!isPreview}
          />
        );
      })}
    </div>
  );
};

export default ProductThree;
